<template>
  <div class="loading_overlay" v-if="loading.single" />
  <div class="md:w-8/12 mx-auto pt-20 px-4 text-white" style="min-height: 70vh">
    <header
      class="text-3xl md:text-4xl mb-2 font-semibold md:leading-normal text-white capitalize"
    >
      Search Results
    </header>
    <template v-if="movies.total_results > 0 || people.total_results > 0">
      <div class="flex my-4 items-center">
        <span class="mr-4" v-if="movies.total_results > 0">
          <button-base
            :disabled="selected.allMovie"
            @click="handleSelected('movie')"
            >Movies
            <span class="ml-2">({{ movies.total_results }})</span></button-base
          >
        </span>
        <span class="mr-4" v-if="people.total_results > 0">
          <button-base
            @click="handleSelected('people')"
            :disabled="selected.allPeople"
            >Celebrity <span class="ml-2">({{ people.total_results }})</span>
          </button-base>
        </span>
        <button-icon
          @click="handleSelected('all')"
          :color="'text-white'"
          v-if="selected.allPeople || selected.allMovie"
        >
          <i class="far fa-times-circle fa-2x"></i
        ></button-icon>
      </div>
      <!-- Movie section -->
      <section
        class="my-8"
        v-if="!selected.allPeople && movies.total_results > 0"
      >
        <subtitle>Related Movies</subtitle>
        <!-- All Movies -->
        <template v-if="selected.allMovie">
          <div>
            <list-movie :movies="movies.results" />
            <!-- Pagination -->
            <div class="mt-20 w-full flex justify-center">
              <v-pagination
                v-if="movies.total_pages > 1"
                v-model="movies.page"
                :pages="movies.total_pages"
                :range-size="1"
                :hideFirstButton="true"
                :hideLastButton="true"
                active-color="#DCEDFF"
                @update:modelValue="val => (pages.movie = val)"
                class="custom-pagination"
              />
            </div>
          </div>
        </template>
        <!-- Filter all movies -->
        <template v-else>
          <div>
            <list-movie :movies="filterMovie" />
            <button-base
              :size="'text-sm'"
              v-if="filterMovie.length == 5"
              @click="handleSelected('movie')"
            >
              See all
            </button-base>
          </div>
        </template>
      </section>
      <!-- Celebrity section -->
      <section
        class="my-8 mt-16"
        v-if="!selected.allMovie && people.total_results > 0"
      >
        <subtitle>Related Celebrity</subtitle>
        <template v-if="selected.allPeople">
          <div>
            <list-celeb :celebs="people.results" />
            <!-- Pagination -->
            <div class="mt-20 w-full flex justify-center">
              <v-pagination
                v-if="people.total_pages > 1"
                v-model="people.page"
                :pages="people.total_pages"
                :range-size="1"
                :hideFirstButton="true"
                :hideLastButton="true"
                active-color="#DCEDFF"
                @update:modelValue="val => (pages.people = val)"
                class="custom-pagination"
              />
            </div>
          </div>
        </template>
        <template v-else>
          <div v-if="filterPeople && filterPeople.length">
            <list-celeb :celebs="filterPeople" />
            <button-base
              :size="'text-sm'"
              v-if="filterPeople.length == 5"
              @click="handleSelected('people')"
            >
              See all
            </button-base>
          </div>
        </template>
      </section>
    </template>
    <template v-else>
      <div class="py-4">
        <p class="text-sm font-semibold mb-2">No results found</p>
      </div>
    </template>
  </div>
</template>

<script>
import { onMounted, watch, ref, computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import ListMovie from "./Partials/ListMovie.vue";
import ListCeleb from "./Partials/ListCeleb.vue";
export default {
  components: { ListMovie, ListCeleb },
  setup() {
    const route = useRoute();
    const store = useStore();
    const selected = ref({
      allMovie: false,
      allPeople: false
    });
    const pages = ref({
      movie: 1,
      people: 1
    });

    const handleSelected = select => {
      if (select === "movie") {
        selected.value = {
          allMovie: true,
          allPeople: false
        };
      }
      if (select === "people") {
        selected.value = {
          allMovie: false,
          allPeople: true
        };
      }
      if (select === "all") {
        selected.value = {
          allMovie: false,
          allPeople: false
        };

        pages.value = {
          movie: 1,
          people: 1
        };
      }
    };

    let filterMovie = computed(() => store.getters["tmdbApi/filterMovie"]);
    let filterPeople = computed(() => store.getters["tmdbApi/filterPeople"]);
    let loading = computed(() => store.state["tmdbApi"].isLoading);
    let movies = computed(() => store.state["tmdbApi"].queryMovie);
    let people = computed(() => store.state["tmdbApi"].queryPeople);

    const queryMovie = async (query, page = 1) => {
      await store.dispatch("tmdbApi/queryMovie", { query, page });
    };
    const queryPeople = async (query, page = 1) => {
      await store.dispatch("tmdbApi/queryPeople", { query, page });
    };

    onMounted(async () => {
      if (route.query["q"]) {
        await queryMovie(route.query["q"]);
        await queryPeople(route.query["q"]);
      }
    });
    watch(
      () => route.query,
      async query => {
        if (query["q"]) {
          await queryMovie(query["q"]);
          await queryPeople(query["q"]);
        }
      }
    );
    watch(
      () => pages.value.movie,
      async page => await queryMovie(route.query["q"], page)
    );
    watch(
      () => pages.value.people,
      async page => await queryPeople(route.query["q"], page)
    );

    return {
      movies,
      people,
      filterMovie,
      filterPeople,
      selected,
      pages,
      loading,
      handleSelected
    };
  }
};
</script>
